import * as Sentry from "@sentry/react";

// Trim whitespace — Railway env vars sometimes include trailing newlines
// which silently break Sentry's DSN parser and prevent event ingestion.
const dsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined)?.trim();

Sentry.init({
  dsn,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  // PostHog handles session recordings — disable Sentry replays entirely
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
